import _slicedToArray from "/home/runner/work/thesensetech/thesensetech/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { useSafeLayoutEffect } from "./use-safe-layout-effect";
/**
 * Credit: https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx
 */

var handoffComplete = false;
var id = 0;

var genId = function genId() {
  return ++id;
};
/**
 * Reack hook to generate unique id
 *
 * @param idProp the external id passed from the user
 * @param prefix prefix to append before the id
 */


export function useId(idProp, prefix) {
  var initialId = idProp || (handoffComplete ? genId() : null);

  var _React$useState = React.useState(initialId),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      uid = _React$useState2[0],
      setUid = _React$useState2[1];

  useSafeLayoutEffect(function () {
    if (uid === null) setUid(genId());
  }, []);
  React.useEffect(function () {
    if (handoffComplete === false) {
      handoffComplete = true;
    }
  }, []);
  var id = uid != null ? uid.toString() : undefined;
  return prefix ? prefix + "-" + id : id;
}
/**
 * Reack hook to generate ids for use in compound components
 *
 * @param idProp the external id passed from the user
 * @param prefixes array of prefixes to use
 *
 * @example
 *
 * ```js
 * const [buttonId, menuId] = useIds("52", "button", "menu")
 *
 * // buttonId will be `button-52`
 * // menuId will be `menu-52`
 * ```
 */

export function useIds(idProp) {
  var id = useId(idProp);

  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }

  return prefixes.map(function (prefix) {
    return prefix + "-" + id;
  });
}